import React, { useState } from "react";
import styled from "styled-components";

const AbschnittPersonalisierte = styled.section`
    width: 100%;
    padding: 30px;
    background-color: #ffcccb;
    box-sizing: border-box;
`;

const ContainerPersonalisierte = styled.div`
    max-width: 600px;
    margin: 30px auto;
`;

const ElementPersonalisierte = styled.div`
    border-bottom: 1px solid #ff9999;
    margin-bottom: 12px;
`;

const TitelPersonalisierte = styled.h3`
    margin: 0;
    padding: 15px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ff9999;
    color: #ffffff;
    border-radius: 6px;
`;

const TextPersonalisierte = styled.div`
    padding: 15px;
    font-size: 16px;
    color: #222222;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    background-color: #ffe6e6;
    border-radius: 0 0 6px 6px;
`;

const FAQ = () => {
  const faqItems = [
    {
      question: "Was ist Troniq.news und wie funktioniert es?",
      answer:
        "Troniq.news ist eine innovative Plattform, die künstliche Intelligenz mit kreativen Lösungen kombiniert, um die Arbeitsprozesse zu optimieren und die Kreativität täglich zu fördern."
    },
    {
      question: "Welche Vorteile bietet die Teilnahme an Troniq.news?",
      answer:
        "Durch die Teilnahme an Troniq.news erhalten Sie Zugang zu modernster Technologie, personalisierter Beratung und werden Teil einer Gemeinschaft, die berufliches und persönliches Wachstum fördert."
    },
    {
      question: "Wie kann ich mich bei Troniq.news anmelden?",
      answer:
        "Der Anmeldeprozess ist einfach: Füllen Sie einfach das Formular auf unserer Website aus und folgen Sie den Anweisungen, um Ihr Konto sofort zu aktivieren."
    },
    {
      question: "Welche Arten von Projekten entwickelt Troniq.news?",
      answer:
        "Wir entwickeln Projekte, die sich auf künstliche Intelligenz, Automatisierung und digitale Transformation konzentrieren, um die Arbeitsweise von Unternehmen zu revolutionieren."
    },
    {
      question: "Brauche ich Vorkenntnisse, um teilzunehmen?",
      answer:
        "Es sind keine Vorkenntnisse erforderlich. Troniq.news ist so gestaltet, dass es sowohl für Anfänger als auch für Profis zugänglich ist und Unterstützung in jeder Phase bietet."
    },
    {
      question: "Wo kann ich mehr Informationen erhalten?",
      answer:
        "Weitere Informationen finden Sie auf unserer Website oder kontaktieren Sie unser Support-Team, das Ihnen gerne bei allen Fragen zur Verfügung steht."
    }
  ];

  const [openItems, setOpenItems] = useState(Array(faqItems.length).fill(false));

  const toggleItem = (index) => {
    setOpenItems((prev) => {
      const newOpenItems = [...prev];
      newOpenItems[index] = !newOpenItems[index];
      return newOpenItems;
    });
  };

  return (
    <AbschnittPersonalisierte>
      <ContainerPersonalisierte>
        {faqItems.map((item, index) => (
          <ElementPersonalisierte key={index}>
            <TitelPersonalisierte onClick={() => toggleItem(index)}>
              {item.question} <span>{openItems[index] ? "–" : "+"}</span>
            </TitelPersonalisierte>
            <TextPersonalisierte isOpen={openItems[index]}>{item.answer}</TextPersonalisierte>
          </ElementPersonalisierte>
        ))}
      </ContainerPersonalisierte>
    </AbschnittPersonalisierte>
  );
};
export default FAQ;